import React, { FC } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, ButtonProps } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { UploadFileOutlined } from '@mui/icons-material';
import DashedWrapper from './DashedWrapper';
import styles from './DropZone.module.scss';

// const CustomizedButton = withStyles({
//   root: {
//     fontFamily: 'Montserrat, sans-serif',
//     textTransform: 'none',
//     fontWeight: 400,
//     boxShadow: 'none',
//     '&:hover': {
//       boxShadow: 'none',
//     },
//     '&:active': {
//       boxShadow: 'none',
//     },
//     '&.MuiButton-sizeLarge': {
//       padding: '17px 29px',
//       minWidth: '250px',
//       fontSize: '18px',
//       lineHeight: '21px',
//     },
//   },
// })(Button);

const CustomizedButton = (props: ButtonProps) => (
  <Button sx={{ fontFamily: 'Montserrat, sans-serif' }} {...props} />
);

// const Label = styled.div`
//   font-size: 18px;
//   text-align: center;
//   color: #000;
// `;
//
// const LabelBold = styled(Label)`
//   font-weight: 500;
// `;
//
// const HelperText = styled.div`
//   color: #777878;
//   font-size: 14px;
// `;
//
// const UploadIconStyled = styled(UploadIcon)`
//   font-size: 20px;
//   vertical-align: text-top;
//   margin-left: 1.5rem;
// `;

interface Props {
  handleDrop: (acceptedFiles: File[]) => void;
  accept?: string;
  acceptLabel?: string;
}

const DropZone: FC<Props> = ({ handleDrop, accept, acceptLabel }: Props) => {
  const onDrop = handleDrop;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const isDesktop = useMediaQuery('(min-width: 600px)');

  if (!isDesktop) {
    return (
      <div {...getRootProps()}>
        <input {...getInputProps()} accept={accept} />
        <div style={{ zIndex: 2 }}>
          <CustomizedButton
            disableTouchRipple
            variant="contained"
            color="primary"
            size="large"
            className="mb-4"
          >
            <span>
              <span>Выбрать файлы</span>
              <UploadFileOutlined className={styles.uploadIcon} />
            </span>
          </CustomizedButton>
          <div className={styles.helperText}>
            <div>{acceptLabel}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <DashedWrapper>
      <div {...getRootProps()}>
        <input {...getInputProps()} accept={accept} />
        <div style={{ zIndex: 2 }}>
          <div className={styles.label}>
            Загрузите файлы или перетащите их в это окно
          </div>
          <CustomizedButton
            disableTouchRipple
            variant="contained"
            color="primary"
            size="large"
            sx={{ my: 4 }}
          >
            <span>
              <span>Выбрать файлы</span>
              <UploadFileOutlined className={styles.uploadIcon} />
            </span>
          </CustomizedButton>
          <div className={styles.helperText}>
            <div>{acceptLabel}</div>
          </div>
        </div>
      </div>
    </DashedWrapper>
  );
};

DropZone.defaultProps = {
  accept: '.jpg,.png,.gif,.odt,.doc,.txt,.pdf',
  acceptLabel: 'jpg, png, gif, odt, doc, txt, pdf',
};

export default DropZone;
